import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';

const TicketDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  // Redirect to AgentWorkspace - check if id is UUID or ticket_number
  React.useEffect(() => {
    // Check if it's a UUID (format: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
    const isUUID = id && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
    if (isUUID) {
      navigate(`/workspace/${id}`, { replace: true });
    } else {
      navigate(`/workspace/number/${id}`, { replace: true });
    }
  }, [id, navigate]);

  return (
    <div style={{ padding: 24 }}>
      <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/tickets')}>
        Back to Tickets
                    </Button>
      <p>Redirecting to workspace...</p>
    </div>
  );
};

export default TicketDetail;
